import React, { FunctionComponent } from "react";
import { DocumentByIdDTO } from "api";
import { UtilityBillFormView } from "./utility-bill-form-view";

export const UtilityBillFormViewForDocument: FunctionComponent<{
  document: DocumentByIdDTO;
  onClose: () => void;
}> = ({ document, onClose }) => <UtilityBillFormView
  document={document}
  onClose={onClose}
/>

